(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.isFixed = null;
      this.prevScrollPos = window.scrollY || document.documentElement.scrollTop;
      this.fixedThreshold = 50;
      this.unfixedThreshold = 20;

      this.updateFixedState(this.prevScrollPos);

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    updateFixedState(scroll) {
      const shouldFix = this.isFixed ? scroll > this.unfixedThreshold : scroll >= this.fixedThreshold;
      if (this.isFixed === shouldFix) return;

      this.isFixed = shouldFix;
      this.header.classList.toggle('header-fixed', shouldFix);
      this.header.classList.toggle('header-fixed-os', !shouldFix);
    }

    onScroll() {
      const scroll = window.scrollY || document.documentElement.scrollTop;

      this.updateFixedState(scroll);

      if (this.prevScrollPos > scroll || scroll === 0) {
        this.header.classList.remove('header-hidden');
      } else {
        this.header.classList.add('header-hidden');
      }

      this.prevScrollPos = scroll;
    }
  }

  // Define the element
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
